/* ==========================================================================
   DH CUSTOM - Mobile nav: single-open accordion
   When a section (Clothing, Accessories, Play, Nursery...) is opened inside a
   drawer panel, collapse its sibling sections so only one stays open at a time.
   Mirrors HOR3.5.1 behaviour. Scoped to the mobile menu drawer.
   Note: Horizon wraps each <details> in an <accordion-custom> element, so we
   resolve the owning <li> with closest('li') and close parent-accordions in
   the *sibling* list items only (descendants of the opened one stay open).
   ========================================================================== */
(function () {
  function isParentAccordion(details) {
    var s = details.firstElementChild;
    return s && s.classList && s.classList.contains('menu-drawer__menu-item--parent');
  }

  function closeSiblings(details) {
    var li = details.closest('li');
    if (!li) return;
    var ul = li.parentElement;
    if (!ul) return;
    Array.prototype.forEach.call(ul.children, function (sib) {
      if (sib === li || sib.tagName !== 'LI') return;
      sib.querySelectorAll('details[open]').forEach(function (other) {
        if (isParentAccordion(other)) other.open = false;
      });
    });
  }

  // `toggle` does not bubble, so listen in the capture phase on the document.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!(d instanceof HTMLDetailsElement) || !d.open) return;
    if (!isParentAccordion(d)) return;
    closeSiblings(d);
  }, true);
})();

/* ==========================================================================
   DH CUSTOM EDITS - Filters

   Behaviour:
   - Desktop filters start closed
   - Mobile filters start closed
   - Only one filter group can be open at a time
   - Sort is excluded
   - An open filter group STAYS open while values are ticked/unticked, so
     shoppers can select multiple values. It only closes when its own header
     is tapped, or when another filter group is opened.
   - Open state is snapshotted before each Horizon AJAX filter update and
     restored afterwards (previously every update collapsed all groups)
   - "Show more" inside a group stays expanded while values are ticked.
     It collapses when that group closes (header tapped, or another group
     opened) or when the mobile filter drawer is closed.
   - Closing the mobile filter drawer (X or "See items") resets every group
     to closed, ready for the next visit
   - Re-applies closed state after desktop/mobile breakpoint changes
   - Re-applies closed state during Theme Editor section reloads

   Horizon facets.js, accordion-custom.js and show-more.js remain untouched.
   ========================================================================== */

(function () {
  'use strict';


  /* ==========================================================================
     SELECTORS
     ========================================================================== */

  var FILTER_PANEL_SELECTOR = [
    '.facets--vertical .facets__filters-wrapper .facets__panel',
    '.facets--drawer .facets__filters-wrapper .facets__panel'
  ].join(', ');


  /* ==========================================================================
     COLLAPSE FILTERS
     ========================================================================== */

  function collapseFilters(root) {
    var scope = root || document;

    scope
      .querySelectorAll(FILTER_PANEL_SELECTOR)
      .forEach(function (panel) {
        if (panel instanceof HTMLDetailsElement) {
          panel.open = false;
        }
      });
  }


  /* ==========================================================================
     COLLAPSE "SHOW MORE"

     Horizon's show-more-component keeps its expanded flag in a private
     field, so we drive it through its public toggle() rather than editing
     classes directly (which would desync its internal state).

     The group is usually already closed when this runs, so the collapse
     animation is invisible; finish it immediately so the component's
     onfinish handler re-hides the extra items and flips its state now.
     ========================================================================== */

  function collapseShowMore(panel) {
    var showMore = panel.querySelector('show-more-component');

    if (
      !showMore ||
      showMore.dataset.expanded !== 'true' ||
      typeof showMore.toggle !== 'function'
    ) {
      return;
    }

    showMore.toggle({ preventDefault: function () {} });

    var content = showMore.querySelector('[ref="showMoreContent"]');

    if (content && typeof content.getAnimations === 'function') {
      content.getAnimations().forEach(function (animation) {
        animation.finish();
      });
    }
  }


  /* ==========================================================================
     SNAPSHOT / RESTORE OPEN STATE

     Each filter <details> has a stable id from list-filter.liquid:
     Facet-Details-{sectionId}-{param}. The desktop sidebar and mobile drawer
     render separate copies, so we record each open panel by id plus which
     wrapper it lives in (drawer vs sidebar) to keep them independent.
     ========================================================================== */

  function panelKey(panel) {
    var inDrawer = !!panel.closest('.facets--drawer');
    return (inDrawer ? 'drawer|' : 'sidebar|') + panel.id;
  }

  function snapshotOpenPanels() {
    var openKeys = [];

    document
      .querySelectorAll(FILTER_PANEL_SELECTOR)
      .forEach(function (panel) {
        if (panel instanceof HTMLDetailsElement && panel.open && panel.id) {
          openKeys.push(panelKey(panel));
        }
      });

    return openKeys;
  }

  function restoreOpenPanels(openKeys) {
    document
      .querySelectorAll(FILTER_PANEL_SELECTOR)
      .forEach(function (panel) {
        if (!(panel instanceof HTMLDetailsElement) || !panel.id) return;

        var shouldBeOpen = openKeys.indexOf(panelKey(panel)) !== -1;

        if (panel.open !== shouldBeOpen) {
          panel.open = shouldBeOpen;
        }
      });
  }


  /* ==========================================================================
     INITIALISE

     Horizon 4.1.4 renders vertical filters with the `open` attribute and
     accordion-custom then establishes its own default state.

     Wait until Horizon's accordion component exists before imposing the
     Daisy & Hen closed state.
     ========================================================================== */

  function initialiseFilters() {
    if (
      window.customElements &&
      typeof window.customElements.whenDefined === 'function'
    ) {
      window.customElements
        .whenDefined('accordion-custom')
        .then(function () {
          requestAnimationFrame(function () {
            collapseFilters(document);
          });
        });

      return;
    }

    requestAnimationFrame(function () {
      collapseFilters(document);
    });
  }


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseFilters,
      { once: true }
    );
  } else {
    initialiseFilters();
  }


  /* ==========================================================================
     ONLY ONE FILTER OPEN AT A TIME
     + RESET "SHOW MORE" WHEN A GROUP CLOSES

     `toggle` does not bubble, therefore capture phase is required.
     Closing the previous group here fires its own `toggle` (closed), which
     is what collapses its "Show more".
     ========================================================================== */

  document.addEventListener(
    'toggle',
    function (event) {
      var openedPanel = event.target;

      if (
        !(openedPanel instanceof HTMLDetailsElement) ||
        !openedPanel.matches(FILTER_PANEL_SELECTOR)
      ) {
        return;
      }

      if (!openedPanel.open) {
        collapseShowMore(openedPanel);
        return;
      }

      var filtersWrapper =
        openedPanel.closest('.facets__filters-wrapper');

      if (!filtersWrapper) {
        return;
      }

      filtersWrapper
        .querySelectorAll('.facets__panel[open]')
        .forEach(function (panel) {
          if (
            panel !== openedPanel &&
            panel instanceof HTMLDetailsElement
          ) {
            panel.open = false;
          }
        });
    },
    true
  );


  /* ==========================================================================
     HORIZON AJAX FILTER UPDATES

     Horizon 4.1.4 dispatches:
     - shopify:collection:update
     - shopify:search:update

     The event fires synchronously inside updateFilters(), BEFORE the section
     HTML is fetched and morphed, so the DOM still reflects what the shopper
     sees. Snapshot the open panels now, then restore exactly that state once
     the render promise resolves.

     Horizon's morph already preserves <details open> in most cases; the
     restore is a safety net for any panel the morph replaces outright.
     ========================================================================== */

  function handleHorizonFilterUpdate(event) {
    var openKeys = snapshotOpenPanels();
    var renderPromise = event.promise;

    function restore() {
      requestAnimationFrame(function () {
        restoreOpenPanels(openKeys);
      });
    }

    if (
      renderPromise &&
      typeof renderPromise.then === 'function'
    ) {
      renderPromise
        .then(restore)
        .catch(function () {
          /*
            Horizon owns its own filtering error handling.
            Do not introduce duplicate customer-facing errors here.
          */
        });

      return;
    }


    /* Safe fallback */

    restore();
  }


  document.addEventListener(
    'shopify:collection:update',
    handleHorizonFilterUpdate,
    true
  );


  document.addEventListener(
    'shopify:search:update',
    handleHorizonFilterUpdate,
    true
  );


  /* ==========================================================================
     MOBILE FILTER DRAWER CLOSED

     theme-drawer#filters-drawer wraps a native <dialog>. Both the X button
     and "See X items" call the drawer's close(), which closes the dialog and
     fires `close` (non-bubbling, so capture phase). Reset every drawer group
     and its "Show more" so the next visit starts clean.
     ========================================================================== */

  document.addEventListener(
    'close',
    function (event) {
      var dialog = event.target;

      if (
        !(dialog instanceof HTMLDialogElement) ||
        !dialog.closest('#filters-drawer')
      ) {
        return;
      }

      dialog
        .querySelectorAll(FILTER_PANEL_SELECTOR)
        .forEach(function (panel) {
          if (!(panel instanceof HTMLDetailsElement)) return;

          collapseShowMore(panel);
          panel.open = false;
        });
    },
    true
  );


  /* ==========================================================================
     DESKTOP / MOBILE BREAKPOINT

     Horizon resets accordion defaults when crossing 750px.
     Restore Daisy & Hen's closed state immediately afterwards.
     ========================================================================== */

  var desktopMedia =
    window.matchMedia('(min-width: 750px)');


  function handleBreakpointChange() {
    requestAnimationFrame(function () {
      collapseFilters(document);
    });
  }


  if (typeof desktopMedia.addEventListener === 'function') {
    desktopMedia.addEventListener(
      'change',
      handleBreakpointChange
    );
  } else if (typeof desktopMedia.addListener === 'function') {
    /* Older Safari */
    desktopMedia.addListener(handleBreakpointChange);
  }


  /* ==========================================================================
     SHOPIFY THEME EDITOR
     ========================================================================== */

  document.addEventListener(
    'shopify:section:load',
    function () {
      requestAnimationFrame(function () {
        collapseFilters(document);
      });
    }
  );

})();